export type ErrorHandler = (error: string | Error, url: string) => never

export function simpleFetch<T>(
  this: ErrorHandler | void,
  url: string,
  options?: RequestInit
): Promise<T> {
  if (this) {
    return simpleFetchImpl<T>(url, options).catch(e => this(e, url))
  } else {
    return simpleFetchImpl<T>(url, options)
  }
}

async function simpleFetchImpl<T>(url: string, options?: RequestInit): Promise<T> {
  const response = await fetch(url, options)

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(errorText)
  }

  const data: T = await response.json()
  return data
}
